import React from "react";
import { ThemeClient } from "./Providers";
import Header from "./Layout/Header";
import Sidebar from "./Layout/Sidebar";

export const Layout = ({ children }) => {
    // console.log("children is", children);
    return (
        <ThemeClient>
            
                {children}
          
        </ThemeClient>
    )
}